import React from 'react';
import { View, ScrollView, Text, ActivityIndicator } from 'react-native';
import theme from '../../../common/theme';
import { styles } from './ScreenSelectionModal.styles';
import ModalTitle from '../ModalTitle/ModalTitle';
import ScreenRow from './ScreenRow';

export interface ScreenSelectionItem {
  key: string | number;
  displayName: string;
  width: number;
  height: number;
  position?: { x: number; y: number };
  isPrimary: boolean;
  isCurrent: boolean;
  isStarred: boolean;
  starredBadgeLabel: string;
  onSelect: () => void;
}

interface Props {
  items: ScreenSelectionItem[];
  loading: boolean;
  isMoving: boolean;
  error: string | null;
  onClose: () => void;
}

const ScreenSelectionModalShell: React.FC<Props> = ({
  items,
  loading,
  isMoving,
  error,
  onClose,
}) => {
  return (
    <View style={styles.container}>
      <ModalTitle title="Select Display" onDismiss={onClose} />
      <View style={styles.content}>
        {error && (
          <View style={styles.errorContainer}>
            <Text style={styles.errorText}>{error}</Text>
          </View>
        )}
        {loading ? (
          <View style={styles.emptyContainer}>
            <ActivityIndicator size="large" color={theme.palette.mono800} />
          </View>
        ) : items.length === 0 ? (
          <View style={styles.emptyContainer}>
            <Text style={styles.emptyText}>No displays found.</Text>
          </View>
        ) : (
          <ScrollView style={styles.list} contentContainerStyle={styles.rows}>
            {items.map(item => (
              <ScreenRow
                key={item.key}
                displayName={item.displayName}
                width={item.width}
                height={item.height}
                position={item.position}
                isPrimary={item.isPrimary}
                isCurrent={item.isCurrent}
                isStarred={item.isStarred}
                starredBadgeLabel={item.starredBadgeLabel}
                isDisabled={isMoving}
                onSelect={item.onSelect}
              />
            ))}
          </ScrollView>
        )}
      </View>
    </View>
  );
};

export default ScreenSelectionModalShell;
